/**
 * @description 获取首页配置
 * @author Kody
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IHomePageInfoParam {
    id?: string;
}

enum textType {
    text = '1',
    textModule = '2',
}

export interface IRes {
    id: string;
    type: textType;
    content: {
        url: string;
        desc: string;
        title: string;
        label: string;
    };
    create_time: string;
    update_time: string;
    enterprise_id: string;
    portalconfig_id: string;
}

export type textRes = IResponse<IRes[] | IRes>;

export const getCustomText = (data: IHomePageInfoParam) => {
    return fetchData(Api.GET_HOME_CUSTOM_TEXT, data).then((res: textRes) => {
        return res;
    });
};
